import React, { useEffect, useState } from "react";
import { Trash2, Mail, Phone, CheckCircle2, Circle } from "lucide-react";
import { api } from "../../api";

export default function Submissions() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try { const { data } = await api.get("/admin/submissions"); setItems(data); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const markRead = async (id) => { await api.put(`/admin/submissions/${id}/read`); load(); };
  const remove = async (id) => { if (!window.confirm("Delete?")) return; await api.delete(`/admin/submissions/${id}`); load(); };

  return (
    <div>
      <h1 className="text-2xl md:text-3xl font-bold">Contact Submissions</h1>
      <p className="text-slate-400 text-sm mt-1">All messages submitted through your public Contact form.</p>

      <div className="mt-6 card-dark overflow-hidden">
        {loading ? (
          <div className="p-10 text-center text-slate-400">Loading...</div>
        ) : items.length === 0 ? (
          <div className="p-10 text-center text-slate-400">No submissions yet</div>
        ) : (
          <ul className="divide-y divide-white/5">
            {items.map((s) => (
              <li key={s.id} className="p-5 hover:bg-white/[0.02]">
                <div className="flex items-start justify-between gap-3 flex-wrap">
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="font-semibold text-white">{s.name}</span>
                      {!s.read && <span className="text-[10px] bg-rose-500/20 text-rose-300 px-2 py-0.5 rounded-full">NEW</span>}
                    </div>
                    <div className="text-xs text-slate-400 mt-1 flex items-center gap-3 flex-wrap">
                      <span className="inline-flex items-center gap-1"><Mail className="w-3 h-3" /> {s.email}</span>
                      {s.phone && <span className="inline-flex items-center gap-1"><Phone className="w-3 h-3" /> {s.phone}</span>}
                      <span>{new Date(s.createdAt).toLocaleString()}</span>
                    </div>
                    <p className="mt-2 text-sm text-slate-300 whitespace-pre-line">{s.message}</p>
                  </div>
                  <div className="flex items-center gap-2">
                    {!s.read && <button onClick={() => markRead(s.id)} className="text-emerald-300 text-xs inline-flex items-center gap-1 px-2 py-1 rounded bg-emerald-500/10 hover:bg-emerald-500/20"><CheckCircle2 className="w-3.5 h-3.5" /> Mark read</button>}
                    <button onClick={() => remove(s.id)} className="text-rose-300 p-1.5 rounded hover:bg-rose-500/10"><Trash2 className="w-4 h-4" /></button>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
